var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwingate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.17188 7.3597V14.0437C4.17188 14.1244 4.26256 14.1719 4.32888 14.1259L6.33895 12.7314C6.36588 12.7127 6.38195 12.682 6.38195 12.6492V8.84903C6.38195 7.58411 6.98026 6.39372 7.99537 5.63901L10.5425 3.74525C10.5679 3.72638 10.5829 3.69662 10.5829 3.665V0.70171C10.5829 0.618992 10.4882 0.572041 10.4223 0.62212L5.75019 4.17608C4.75573 4.93253 4.17188 6.11023 4.17188 7.3597Z",
    fill: "#141414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37793 9.62532V16.3082C7.37793 16.3891 7.46904 16.4366 7.53532 16.3901L12.0844 13.2023C13.1528 12.4537 13.7889 11.2311 13.7889 9.92657V2.96734C13.7889 2.88462 13.6942 2.83767 13.6284 2.88774L8.95624 6.4417C7.96178 7.19816 7.37793 8.37585 7.37793 9.62532Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwingate);
export default __webpack_public_path__ + "static/media/Twingate.092fc91d5fd02765ca04b4b1037dd421.svg";
export { ForwardRef as ReactComponent };